import { useTranslation } from 'react-i18next';
import { ListItem, ListItemButton, ListItemText, IconButton, Tooltip } from '@mui/material';
import { 
    Delete as DeleteIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon
} from '@mui/icons-material';
import FieldName from './FieldName';
import FieldIcon from './FieldIcon';
const FieldListItem = ({ field, selected, onDelete, canMoveUp, canMoveDown, onMoveUp, onMoveDown, ...props }) => {
    const { t } = useTranslation();

    return (
        <ListItem 
            disablePadding
            selected={selected}
            sx={{
                '&.Mui-selected': {
                    backgroundColor: 'background.default',
                    '&:hover': {
                        backgroundColor: 'background.default',
                    }
                }
            }}
            secondaryAction={
                <div style={{ 
                    display: selected ? 'flex' : 'none'
                }}>
                    <Tooltip title={t('Move up')} placement="top" arrow>
                        <IconButton color="primary" onClick={onMoveUp} disabled={!canMoveUp}>
                            <ArrowUpwardIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t('Move down')} placement="top" arrow>
                        <IconButton color="primary" onClick={onMoveDown} disabled={!canMoveDown}>
                            <ArrowDownwardIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t('Delete')} placement="top" arrow>
                        <IconButton color="primary" onClick={onDelete}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            }
            {...props}
        >
            <ListItemButton>
                <FieldIcon type={field.type} />
                <ListItemText primary={<FieldName field={field} />} sx={{ mr: 10 }} />
            </ListItemButton>
        </ListItem>
    );
};

export default FieldListItem;
